import Hero from '../compnents/Home/hero';
import Bar from '../compnents/Home/bar';
import About from '../compnents/Home/About';
import FunFact from '../compnents/Home/FunFact';
import Connection from '../compnents/Home/Connection';
import How from '../compnents/Home/How';

const Home = () => {
	return (
		<main className='mt-16'>
			<Hero />
			<section className='space-y-24 '>
				<Bar />
				<About />
				<FunFact />
				<How />
				<Connection />
			</section>
		</main>
	);
};
export default Home;
